import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

const STORAGE_KEY = 'polya-appointments-language';

@Injectable({
  providedIn: 'root'
})
export class CustomTranslateService {
  constructor(private translate: TranslateService) {}

  addLangs(langs: string[]): void {
    this.translate.addLangs(langs);
  }

  setDefaultLang(lang: string): void {
    this.translate.setDefaultLang(lang);
  }

  use(lang: string): void {
    this.translate.use(lang);
  }

  getCurrentLang(): string {
    return this.translate.currentLang || this.translate.getDefaultLang() || 'de';
  }

  getLangFromLocalStorage(): string | null {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? raw.toLowerCase() : null;
  }

  setLangToLocalStorage(lang: string): void {
    if (!lang) return;
    localStorage.setItem(STORAGE_KEY, lang.toLowerCase());
  }
}
